export enum EEventPostType {
  EVENT_POST_NEWS = 'EVENT_POST_NEWS',
  EVENT_POST_RECAP = 'EVENT_POST_RECAP',
}

export enum EEventPostTypeLabel {
  EVENT_POST_NEWS = 'Event News',
  EVENT_POST_RECAP = 'Event Recap',
}

// Event post status enums
export enum EEventPostStatus {
  PUBLISHED = 1,
  UNPUBLISHED = 0,
}

// Event post tabs for navigation
export enum EEventPostTabs {
  CONTENT = 'Content',
  META = 'Meta',
}
